import React from 'react';
import MuiCheckbox, { checkboxClasses, CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { SxProps, Theme, alpha, styled, useTheme } from '@mui/material/styles';
import { CheckboxIcon } from './CheckboxIcon';
const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => ({
  color: '#D5D7DA',
  borderRadius: '6px',
  [`&.${checkboxClasses.root}`]: {
    padding: '4px',
    borderRadius: '10px',
    '&.MuiCheckbox-sizeSmall': {
      padding: '3px',
      borderRadius: '6px',
    },
    '&:hover': {
      backgroundColor: '#D5D7DA',
      '& .unchecked-icon': {
        fill: 'white',
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: alpha(theme.palette.primary.main, 0.3),
    },
  },
}));
type CheckboxProps = Pick<
  MuiCheckboxProps,
  | 'size'
  | 'disabled'
  | 'checked'
  | 'onChange'
  | 'indeterminate'
  | 'slotProps'
  | 'required'
  | 'autoFocus'
  | 'onBlur'
  | 'onFocus'
> & {
  id?: string;
  sx?: SxProps<Theme>;
};
export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  const { palette, custom } = useTheme();
  const iconSize = props.size === 'small' ? 16 : props.size === 'medium' ? 20 : 24;
  const iconColor = props.disabled ? custom?.colours?.grey300 || '#D0D5DD' : palette.primary.main;
  return (
    <StyledCheckbox
      {...props}
      ref={ref}
      focusRipple={false}
      checkedIcon={<CheckboxIcon size={iconSize} color={iconColor} checked={true} />}
      icon={<CheckboxIcon size={iconSize} color={iconColor} checked={false} />}
      indeterminateIcon={<CheckboxIcon size={iconSize} color={iconColor} indeterminate={true} />}
      sx={{
        '&:hover': {
          '&.Mui-checked.Mui-indeterminate': {
            '& svg > .indeterminate-icon-rect-1': {
              fill: palette.primary.main,
            },
            '& svg > .indeterminate-icon-rect-2': {
              fill: 'white',
            },
          },
          '&.Mui-checked': {
            '& .checked-icon > rect': {
              fill: palette.primary.main,
            },
            '& .checked-icon > path': {
              fill: 'none',
            },
          },
        },
      }}
    />
  );
});
Checkbox.displayName = 'Checkbox';
